import { Button, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { Backend } from "../services/Backend";
import moment from "moment";

export default function HomePage() {
    const [searchQuery, setSearchQuery] = useState("");
    const [news, setNews] = useState([]);

    const handleSearch = () => {
        window.location.href = `/search-best-practice?search=${searchQuery}`;
    }

    useEffect(() => {
        async function fetchData() {
            const res = await Backend.get(`news/last`);
            for (let newsItem of res) {
                try {
                    const photoLink = await Backend.download(`attachment/${newsItem.photo}`)
                    newsItem.photo =  URL.createObjectURL(photoLink);
                } catch(e) {
                    console.error(e);
                }
            }
            setNews(res);
            console.log(res);
        } 

        fetchData();
    }, []);

    function getTextFromFirstTag(htmlString) {
        const match = htmlString.match(/<[^>]+>([^<]*)<\/[^>]+>/);
        
        return match ? match[1] : null;
    }

    return <div>
        <img src="/img/banner.jpg" className="w-[100%] h-[500px] object-cover"/>
        <div className="flex gap-3 w-[50%] mx-auto">
            <TextField margin="normal" size="small" required fullWidth label="Search" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)}  />
            <Button  variant="contained" sx={{ mt: 2, mb: 1 }} onClick={handleSearch}>Search</Button>
        </div>
        <br />
        <div className="w-[50%] mx-auto">
                {news.map(item => <div className="flex gap-5 mb-4">
                    <img src={item.photo} className="w-[100px]"/>
                    <div >
                        <a className="text-black" href={`/news/${item.id}`}><b>{item.title}</b></a>
                        <br />
                        <i>{moment(item.uploadDate).local().format("YYYY-MM-DD")}</i>
                        <p>{getTextFromFirstTag(item.description).split('. ')[0]} <a href={`/news/${item.id}`}>Read more</a></p>
                    </div>
                </div>)}
            </div>
    </div>
}